import { Box, Button, Modal } from "@mui/material";

interface InfoModalProps {
    isVisible: boolean;
    handleClose: () => Promise<void>;
}

const InfoModal = ({ isVisible, handleClose }: InfoModalProps) => {
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '840px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return (
        <Modal
            open={isVisible}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={modalStyle}>
                Create a ticket in <a target="_blank" href="https://pwcnetwork.service-now.com/hub?id=sc_cat_item&sys_id=6ae80f7ddbd583409f5c34bffe9619ef">ServiceNow</a><br/><br/>
                <Button style={{ margin: '20px', float: 'right', width: '100px' }} variant="contained" color="info" onClick={handleClose}>Close</Button>
            </Box>
        </Modal>
    );
};

export default InfoModal;